export const customPageTypes = {
  project: {
    editorType: "group",
    type: "GAME",
    name: {
      editorType: "language",
      fr: "Nouveau Projet",
      en: "New Project",
    },
    description: {
      editorType: "language",
      fr: "Default description for new Project",
      en: "",
    },
    image: {
      editorType: "language",
      fr: {
        editorType: "imageSelector",
        value:
          "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fplaceholder%2Fplaceholder.png?alt=media&token=499319ad-3327-4f5c-84cb-b44027484cfe",
        title: "placeholder.png",
      },
      en: {
        editorType: "imageSelector",
        value: "",
        title: "",
      },
    },
    fav: false,
    brouillon: false,
  },
  article: {
    editorType: "group",
    name: {
      editorType: "language",
      fr: "Nouveau Projet",
      en: "New Project",
    },
    description: {
      editorType: "language",
      fr: "Default description for new Project",
      en: "",
    },
    image: {
      editorType: "language",
      fr: {
        editorType: "imageSelector",
        value:
          "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fplaceholder%2Fplaceholder.png?alt=media&token=499319ad-3327-4f5c-84cb-b44027484cfe",
        title: "placeholder.png",
      },
      en: {
        editorType: "imageSelector",
        value: "",
        title: "",
      },
    },
    brouillon: false,
  },
  test: {
    editorType: "group",
  },
};
